import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const bankAccountModelGet = ({buildingId = '', bankId = '', coinId = '', userId = '', }) => {
    return {
        //buildingId: buildingId,
        bankId: bankId,
        coinId: coinId,
        //userId: userId,
        //created: dateTimeStr,
        date: dateTimeStr,
        currentBalance: decimal,
        initialBalance: decimal,
        inactive: false,
        number: str,
        type: str,
        ...baseBUCGet({buildingId: buildingId, userId: userId, }),
    }
};